import { FCM_TOKEN_STORAGE_KEY } from 'constants';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { LocalJsonStorage } from 'utils/storage';
import http from 'services/http';
import { isApp } from 'utils/app';
import { useEffect } from 'react';
import { captureException } from 'utils/error';
import { App } from '@capacitor/app';
import useConfig from 'hooks/useConfig';

const addListeners = async ({ orgId }) => {
  console.log('add listeners');
  await PushNotifications.addListener('registration', async (token) => {
    console.log('Registration token: ', token.value);
    LocalJsonStorage.set({ key: FCM_TOKEN_STORAGE_KEY, value: token.value });
    http.post('/v1/user/customer/fcm-token/', {
      organization: orgId,
      token: token.value,
      os: Capacitor.getPlatform(),
      application_version: (await App.getInfo()).version,
    });
  });

  await PushNotifications.addListener('registrationError', (err) => {
    console.error('Registration error: ', err.error);
  });

  await PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Push notification received: ', notification);
  });

  await PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
    console.log('Push notification action performed', notification.actionId, notification.inputValue);
  });
};

export function usePushNotifications({ isLoggedIn }) {
  const orgId = useConfig('general.id');
  useEffect(() => {
    if (!isApp()) {
      return;
    }
    try {
      addListeners({ orgId });
      setTimeout(async () => {
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
          permStatus = await PushNotifications.requestPermissions();
        }
      }, 3000);
    } catch (e) {
      console.error('Notification Error', e.message, e);
    }
  }, []);

  useEffect(() => {
    if (!isApp()) {
      return;
    }
    (async () => {
      try {
        if (isLoggedIn) {
          await PushNotifications.register();
        } else {
          await PushNotifications.unregister();
          LocalJsonStorage.set({ key: FCM_TOKEN_STORAGE_KEY, value: null });
        }
      } catch (e) {
        captureException(e);
      }
    })();
  }, [isLoggedIn]);
}
